import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import PtcBadge from '@/components/common/ptc/PtcBadge'
import FilterJourneyInfo from '@/components/srp/Filters/FilterJourneyInfo'
import { filterTypes } from '@/constants/Srp'
import { PossibleFilterTypes, PtcFareFilterType } from '@/types/srp'

import CheckboxItem from '../checkboxItem'

interface PtcFareFilterProps {
  ptcFare: PtcFareFilterType
  from: string
  isRT: boolean
  to: string
  legIsOnward: boolean
  isRevamp?: boolean
  onFilterChange: (
    type: PossibleFilterTypes,
    selectedValues: PtcFareFilterType,
    index: number,
    legKey: 'onwardLeg' | 'returnLeg'
  ) => void
}

const PtcFareFilter = ({
  ptcFare,
  from,
  to,
  legIsOnward,
  onFilterChange,
  isRT,
  isRevamp = false,
}: PtcFareFilterProps) => {
  const { checked } = ptcFare
  const ptcFareText = 'Student Fare'

  const onChange = () => {
    onFilterChange(
      filterTypes.PTC_FARE,
      { ...ptcFare, checked: !checked },
      legIsOnward ? 0 : 1,
      legIsOnward ? 'onwardLeg' : 'returnLeg'
    )
  }
  return (
    <Container className={isRevamp ? 'flex flex-column' : 'py-3'}>
      {isRT && <FilterJourneyInfo from={from} isRevamp={isRevamp} isRT={isRT} to={to} />}
      <CheckboxItem
        key={`ptcfilter-${legIsOnward ? 'onward' : 'return'}`}
        checked={checked}
        label={
          <Container className='flex flex-middle'>
            <Typography className='c-pointer' variant={isRevamp ? 'B2' : 'P2'}>
              {ptcFareText}
            </Typography>
            <Container className='ml-1'>
              <PtcBadge />
            </Container>
          </Container>
        }
        wrapperClassName={'py-2 w-100p checkbox-hover-border'}
        onClick={onChange}
      />
    </Container>
  )
}

export default PtcFareFilter
